export default __webpack_public_path__ + "static/media/quickTime.ffe0cfd5.svg";